export default "__VITE_ASSET__Cze6W8pg__"